import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-class" }
const _hoisted_2 = { class: "modal-header justify-content-center mt-2" }
const _hoisted_3 = { class: "modal-body mx-4" }
const _hoisted_4 = { class: "d-flex justify-content-end m-3 mt-4" }

import { ref, watch } from "vue"
import { GDialog } from 'gitart-vue-dialog'
import i18n from '@/lang/i18n';

type Props = {
  modalState: boolean,
  title?: string,
  titleClass?: string,
  subTitle?: string,
  subTitleClass?: string,
  note?: string,
  noteClass?: string,
  leftBtnName?: string | null,
  leftBtnClass?: string,
  rightBtnName?: string | null,
  rightBtnClass?: string,
  modalMaxWidth?: string,
  leftLoading?: boolean,
  rightLoading?: boolean,
};

export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationModalBase',
  props: {
    modalState: { type: Boolean, default: false },
    title: { default: i18n.global.t('common.confirmationModal.title') },
    titleClass: { default: 'confirmation-modal-title' },
    subTitle: {},
    subTitleClass: { default: 'confirmation-modal-subtitle' },
    note: {},
    noteClass: { default: 'confirmation-modal-note' },
    leftBtnName: { default: i18n.global.t('common.confirmBtn') },
    leftBtnClass: { default: 'exec-btn' },
    rightBtnName: { default: i18n.global.t('common.cancelBtn') },
    rightBtnClass: { default: 'reset-btn' },
    modalMaxWidth: {},
    leftLoading: { type: Boolean, default: false },
    rightLoading: { type: Boolean, default: false }
  },
  emits: ['leftBtnAction', 'rightBtnAction'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const localModalState = ref(false)

watch(() => props.modalState, (value) => {
  localModalState.value = value
})

const emits = __emit

function leftBtnAction() {
  emits("leftBtnAction");
}

function rightBtnAction() {
  emits("rightBtnAction");
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_unref(GDialog), {
    "content-class": "confirmation-modal",
    modelValue: localModalState.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localModalState).value = $event)),
    transition: "custom-from-bottom-transition",
    persistent: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", {
            class: _normalizeClass(props.titleClass)
          }, _toDisplayString(props.title), 3)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            class: _normalizeClass(props.subTitleClass)
          }, _toDisplayString(props.subTitle), 3),
          _renderSlot(_ctx.$slots, "supplementary-item"),
          _createElementVNode("div", {
            class: _normalizeClass(props.noteClass)
          }, [
            _renderSlot(_ctx.$slots, "note", {}, () => [
              _createTextVNode(_toDisplayString(props.note), 1)
            ])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_btn, {
            class: _normalizeClass(["ma-2 exec-btn", props.leftBtnClass]),
            onClick: leftBtnAction,
            loading: props.leftLoading
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.leftBtnName), 1)
            ]),
            _: 1
          }, 8, ["class", "loading"]),
          _createVNode(_component_v_btn, {
            class: _normalizeClass(["ma-2 reset-btn", props.rightBtnClass]),
            onClick: rightBtnAction,
            loading: props.rightLoading
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.rightBtnName), 1)
            ]),
            _: 1
          }, 8, ["class", "loading"])
        ])
      ])
    ]),
    _: 3
  }, 8, ["modelValue"]))
}
}

})